<template>
  <Dialog
    :open="modalVisible"
    @update:open="(value) => emits('close', value)"
  >
    <CustomerCertificationNotificationModalContent
      :customer="customer"
      :program-id="programId"
      :feature="feature"
      @sent="$emit('close')"
    />
  </Dialog>
</template>

<script lang="ts" setup>
import Customer from "@/customer/interfaces/Customer";
import {Dialog} from "@/core/components/ui/dialog";
import CustomerCertificationNotificationModalContent
    from "@/customer-certification/components/certification-modal/CustomerCertificationNotificationModalContent.vue";

const {modalVisible, customer, programId, feature} = defineProps<{
    modalVisible: boolean;
    customer: Customer;
    programId?: number;
    feature?: string;
}>();

const emits = defineEmits(['close']);
</script>
